import { useState } from 'react'
import Modal from './Modal.jsx'
import { calculate, SYRINGES, DOSE_UNITS } from '../lib/peptide.js'

/*
 * Edit a saved calculation's vial, water, dose, syringe, and name — not just
 * the title. Live-previews the resulting units and doses per vial.
 */
export default function EditCalcModal({ calc, onClose, onSave }) {
  const [f, setF] = useState({
    name: calc.name || '',
    vialMg: calc.vialMg ?? '',
    waterMl: calc.waterMl ?? '',
    dose: calc.dose ?? '',
    doseUnit: calc.doseUnit || 'mcg',
    syringe: calc.syringe || 's100',
  })
  const [saving, setSaving] = useState(false)
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }))
  const res = calculate(f)

  const submit = async () => {
    setSaving(true)
    await onSave({
      name: f.name.trim() || 'Untitled',
      vialMg: f.vialMg, waterMl: f.waterMl, dose: f.dose, doseUnit: f.doseUnit, syringe: f.syringe,
    })
    setSaving(false)
  }

  return (
    <Modal title="Edit calculation" onClose={onClose}>
      <div className="modal-body">
        <div className="field">
          <label className="label">Name</label>
          <input className="input" value={f.name} onChange={(e) => set('name', e.target.value)} />
        </div>
        <div className="grid-2">
          <div className="field">
            <label className="label">Peptide (mg)</label>
            <input className="input" type="number" step="any" value={f.vialMg} onChange={(e) => set('vialMg', e.target.value)} />
          </div>
          <div className="field">
            <label className="label">Water (mL)</label>
            <input className="input" type="number" step="any" value={f.waterMl} onChange={(e) => set('waterMl', e.target.value)} />
          </div>
        </div>
        <div className="field">
          <label className="label">Dose</label>
          <div className="row" style={{ gap: 10 }}>
            <input className="input" type="number" step="any" value={f.dose} onChange={(e) => set('dose', e.target.value)} style={{ flex: 1 }} />
            <div className="seg">
              {DOSE_UNITS.map((u) => (
                <button key={u.id} type="button" className={f.doseUnit === u.id ? 'active' : ''} onClick={() => set('doseUnit', u.id)}>{u.label}</button>
              ))}
            </div>
          </div>
        </div>
        <div className="field mb-0">
          <label className="label">Syringe size</label>
          <div className="seg" style={{ width: '100%' }}>
            {SYRINGES.map((s) => (
              <button key={s.id} type="button" style={{ flex: 1 }} className={f.syringe === s.id ? 'active' : ''} onClick={() => set('syringe', s.id)}>{s.capacity}u</button>
            ))}
          </div>
        </div>

        {res.ok && (
          <div className="pill blue" style={{ marginTop: 14 }}>
            Now: {res.units} units per dose · {res.dosesPerVial} doses per vial
          </div>
        )}
      </div>
      <div className="modal-foot">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={submit} disabled={saving}>{saving ? 'Saving…' : 'Save changes'}</button>
      </div>
    </Modal>
  )
}
